import extend from 'extend'

export default obj => extend(true, {}, obj)
